import React from "react";
import { Section, WorksContainer } from "./style";
import { Title } from "components/shared";
import data from "./WorkData";
import WorkCard from "./WorkCard";

export default function Works() {
    return (
        <Section id="works">
            <Title>Works</Title>
            <WorksContainer>
                {data.map((item) => (
                    <WorkCard key={item.id} details={item} />
                ))}
            </WorksContainer>
        </Section>
    );
}
